import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";

const SalesChart = () => {
  const [hourlyData, setHourlyData] = useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      axios
        .get("./dati_dashboard.json")
        .then((res) => {
          setHourlyData(res.data.SUD.orario);
        })
        .catch((err) => {
          alert(err);
          setIsError(!isError);
          setError({ error });
        });
    };
    fetchData();
  }, []);

  const maxYValue =
    Math.max(...hourlyData.map((dataPoint) => dataPoint.valore)) + 1000;

  return (
    <Card className="ombra border-light card-home graphic-day hover-effect">
      <div className="mt-1 mx-auto">
        <p className="text-title3 fs-6 p-1">
          ORDINI PER OGNI ORA
        </p>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={hourlyData}
          width={730}
          height={170}
          margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
          className="gd" 
        >
          <XAxis dataKey="orario"  fill="black"
        className="fw-bold"
        style={{ fontSize: "0.6em" }}/>
          <YAxis
           fill="black"
           className="fw-bold"
           style={{ fontSize: "0.6em" }}
            domain={[0, maxYValue]}
            tickFormatter={(value) =>
              `${parseFloat(value).toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            }
          />{" "}
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip
            formatter={(value, name) => [
              `${parseFloat(value).toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
              name,
            ]}
          />
          <Line type="monotone" dataKey="valore" stroke="red" strokeWidth={3} />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default SalesChart;
